import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PATH } from '../../../constants';

import LinkMore from '../LinkMore/LinkMore';
import Loader from '../Loader/Loader';


const LinksBoxWithEntries = ({
    entries,
    isFetching = true,
    category = null,
    boxName = null
}) => {
    const { t } = useTranslation();

    if (isFetching) {
        return <Loader spinner />;
    }

    const renderListOfLinks = () =>
        entries?.slice(0, 3)?.map((item) => (
            <li key={item.id} className="links-box__item">
                <Link
                    className="link"
                    to={`${PATH.helpAndSupport}/${item.categoryId}/${item.id}`}
                    title={item.name}
                    state={{ entryName: item.name }}
                >
                    {item.name}
                </Link>
            </li>
        ));

    return (
        <div className="links-box links-box--with-entries">
            <h2 className="links-box__name">{boxName}</h2>
            <ul>{renderListOfLinks()}</ul>
            <LinkMore
                additionalClassNames="links-box__more"
                contentId={category}
                anchor={t('ui.shared.categoryLinkText')}
                name={boxName}
            />
        </div>
    );
};

export default LinksBoxWithEntries;
